<div class="checkboxContainer d-inline-flex align-items-center">
  <input type="checkbox" [id]="'custom_checkbox_'+uniqueId" class="standardInput d-inline" [(ngModel)]="checked">
  <label [for]="'custom_checkbox_'+uniqueId" class="custom-checkbox" [ngClass]="{checked: checked}"></label>
  <label [for]="'custom_checkbox_'+uniqueId" class="custom-checkbox-label">{{label}}</label>
</div>
